import {File} from "~/dto/File.js";
import {Param} from "~/dto/Param.js";

export class Product {

    id;
    name;
    description;
    /**
     *
     * @type {File[]}
     */
    files = [];
    /**
     *
     * @type {null|File}
     */
    mainImage = null;
    metaKeywords = "";
    metaDescription = "";
    /**
     *
     * @type {Product[]}
     */
    variants = [];
    /**
     *
     * @type {Param[]}
     */
    params = [];
    price = 0;
    priceOld = 0;
    pricePurchase = 0;
    amount = 3;
    closest = [];
    /**
     * @type Product
     */
    parent = null;
    tree = [];
    /**
     *
     * @type {Product[]}
     */
    set = [];
    video = "";
    taxonomies = [];
    type = 0;
    buttonTitle = null;

    static getButtonTitle(type) {
        switch (type) {
            case 1:
                return "Оставить заявку";
            case 2:
                return "Предзаказ";
            default:
                return "В корзину";
        }
    }

    static createFromObj(obj) {
        const p = new Product(obj.id, obj.name);
        p.description = obj.description;
        p.files = obj.files.map(el => File.createFromObj(el));
        p.mainImage = obj.mainImage;
        p.metaKeywords = obj.metaKeywords;
        p.metaDescription = obj.metaDescription;
        p.variants = obj.variants.map(el => Product.createFromObj(el));
        p.params = obj.params.map(el => Param.createFromObj(el));
        p.price = obj.price;
        p.priceOld = obj.priceOld;
        p.pricePurchase = obj.pricePurchase;
        p.amount = obj.amount;
        p.closest = obj.closest ?? [];
        p.tree = obj.tree;
        p.video = obj.video === "null" ? null : obj.video;
        p.type = obj.type;
        if (obj.taxonomies) p.taxonomies = obj.taxonomies;
        if (obj.parent) p.parent = Product.createFromObj(p);
        if (obj.set) p.set = obj.set.map(el => Product.createFromObj(el));
        p.buttonTitle = obj.buttonTitle || Product.getButtonTitle(p.type);

        return p;
    }

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }

    get imgPath() {
        return this.mainImage?.path;
    }

    /**
     *
     * @return {Param[]}
     */
    get notSelectableParams() {
        return this.params.filter(el => !el.selectable);
    }

    /**
     *
     * @return {Param[]}
     */
    get selectableParams() {
        return this.params.filter(el => el.selectable);
    }

    /**
     *
     * @return {File[]}
     */
    get images() {
        return this.files.filter(el => el.isImage);
    }

    get isSet() {
        return this.taxonomies.find(el => el.id === 60);
    }

    /**
     *
     * @param variantId
     * @return {Product}
     */
    getVariant(variantId) {
        if (variantId === this.id) return this;
        return this.variants.find(el => el.id === variantId);
    }

}